import { Listing } from './../../../classes/listing';
import { delay } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Input, ViewChild, ElementRef, HostListener } from '@angular/core';
import { LOCALLOGIC_SCRIPT } from '../../../classes/dynamicScripts';
import { DomManipulationService } from '../../../services/dom-manipulation/dom-manipulation.service';
import { combineLatest } from 'rxjs';
import { HasSubscriptions } from '../../../components/has-subscriptions';

declare var locallogic: any;

@Component({
  selector: 'app-poi-widget',
  template: `<div class="poiWidget-container" #poiWidget>
                <div *ngIf="isLoaded"  class="toggle toggle-right" #toggleContainer>
                  <div class="toggle-container">
                    <label>Lifestyle</label>
                    <app-switch [inputId]="'localLogicSwitch'" [checked]="showPOI" (checkedChange)="toggle()"></app-switch>
                  </div>
                </div>
                <div class="poiWidget" id="poiWidget" ><div>
             </div>
        `,
  styleUrls: ['./poi-widget.component.scss']
})
export class PoiWidgetComponent extends HasSubscriptions implements OnInit {

  @ViewChild('toggleContainer') toggleContainer: ElementRef;
  @ViewChild('poiWidget') poiWidget: ElementRef
  @Input() listing: Listing;

  showPOI = false;
  DESKTOP_SIZE = 1366;
  isLeft: boolean = true;
  isLoaded = false;

  constructor(
    private _domManipulationService: DomManipulationService,
    private _translateService: TranslateService,
  ) {
    super();
  }

  /**
   * Hide the bar side bar or top bar on local logic map if the switch is off.
   * Toggle back on if the switch is on.
   */

  toggle() {
    this.showPOI = !this.showPOI;
    const ele = document.getElementsByClassName('ll-list-container');
    if (!this.showPOI && ele) {
      if (!this.isLeft) {
        this.toggleContainer.nativeElement.style.top = '10px';
      }
      ele[0]['style'].display = 'none';
    } else {
      if (!this.isLeft) {
        this.toggleContainer.nativeElement.style.top = '90px';
      }
      ele[0]['style'].display = 'block';
    }
  }

  // Based on the width of the screen we need to position the switch properly
  // When the screen size is less then 1366px then the switch should be under the top bar
  // When the screen size is over 1366px then we want the switch to be to the rightmost of the map
  positionToggle() {
    this.isLeft = this.poiWidget.nativeElement.clientWidth >= 750;
  }

  ngOnInit() {
    if (!this.listing.isOffMarket) return; // Do not use this for non-offmarket pages for now
    this.addSub(combineLatest(
        this._domManipulationService.loadScript(LOCALLOGIC_SCRIPT) // load the script first
      ).pipe(delay(0))
      .subscribe(() => {
        const x = new locallogic.LocalContent('poiWidget', { // load local logic in the div with options
          lat: this.listing.lat,
          lng: this.listing.lng,
          color: '#004E9B',
          locale: this._translateService.getBrowserLang(),
          callback: () => this.showPOI = false,
          basemap: 'google'
        })
        this.onMapLoad();
      })
    );
  }

  onMapLoad() {
    const myTimer = setInterval(() => {
      const widget = document.getElementsByClassName('ll-list-container');
      if (widget && widget.length > 0) {
        this.positionToggle();
        widget[0]['style'].display = 'none';
        this.isLoaded = true;
      }
      if (this.isLoaded) {
        clearInterval(myTimer);
      }
    }, 100)
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (!this.listing.isOffMarket) return;
    this.isLoaded = false;
    // this.positionToggle();
    this.onMapLoad();
  }
}
